import di from "../di/servicelocator";
import { ESortOrder } from "@domains/utils/sort";
import React, { useState } from "react";
import "../../../../stylesheets/components/Reports/HoldingReports/SortDrop.scss";
const SortDrop = ({ setSortoptionSelected, setshowSortDropdown, sortByFilters, setSortByFilters, themeClass, }) => {
    const [sortState, setSortState] = useState(sortByFilters);
    const [id, setId] = useState(0);
    const [sortKeyDisplayState, setSortKeyDisplayState] = useState({
        Alphabetical: { asc: "Z to A", desc: "A to Z" },
        "P&L %": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "P&L absolute": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "LTP Change %": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Day Change": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Investment Value": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Current Value": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
    });
    const sortByFunction = async (idx) => {
        setSortByFilters === null || setSortByFilters === void 0 ? void 0 : setSortByFilters(sortState);
        const sort = sortState[idx];
        di.holdingReport.getSortedHoldingReportData(sort, true);
        //set red dot on sort function
        setSortoptionSelected === null || setSortoptionSelected === void 0 ? void 0 : setSortoptionSelected(true);
        setshowSortDropdown(false);
    };
    const resetSort = () => {
        di.holdingReport.getSortedHoldingReportData({
            displayName: "Alphabetical",
            order: ESortOrder.DESC,
            sortName: "displayName",
        }, false);
        setshowSortDropdown(false);
    };
    const setSortOrder = (idx, key, value) => {
        setId(idx);
        let tempData = sortState.map((val) => {
            return Object.assign({}, val);
        });
        tempData[idx].order =
            value === ESortOrder.DESC ? ESortOrder.ASC : ESortOrder.DESC;
        tempData = tempData.map((value, id) => {
            if (id !== idx)
                value.order = ESortOrder.UNCHANGED;
            return value;
        });
        setSortState(tempData);
    };
    return (React.createElement("div", { className: `${themeClass !== null && themeClass !== void 0 ? themeClass : " sort-drop"}` },
        React.createElement("div", { className: "sort-drop-body" },
            " ",
            React.createElement("ul", { className: "sort-drop-bodylist" }, sortState.map((val, idx) => {
                return (React.createElement("li", { key: idx, onClick: () => setSortOrder(idx, val.displayName, val.order), style: {
                        color: sortState[idx].order === 0 ? "#444444" : "#3580F7",
                    } },
                    React.createElement("label", null, val.displayName),
                    React.createElement("span", { className: "bodylist-right" },
                        React.createElement("p", { className: "light-right", style: {
                                color: sortState[idx].order === 0 ? "#B8B8B8" : "#3580F7",
                            } }, sortKeyDisplayState[val.displayName][val.order === ESortOrder.ASC ? "asc" : "desc"]),
                        val.order == ESortOrder.ASC ? (React.createElement("span", null,
                            React.createElement("i", { className: "edel-icon-point-arrow-up" }))) : (React.createElement("span", null,
                            React.createElement("i", { className: "edel-icon-point-arrow-down" }))))));
            }))),
        React.createElement("div", { className: "sort-drop-footer" },
            React.createElement("input", { className: `reset-button`, onClick: resetSort, type: "button", value: "Reset" }),
            React.createElement("input", { className: `filter-button`, onClick: () => sortByFunction(id), type: "button", value: "Apply" }))));
};
export default SortDrop;
